import React from "react";
import FastApiAuth from "../FastApiClient/FastApiAuth";

const fastApi = new FastApiAuth({
    timeout: 2000,
});

function LoginPage(props) {

    const [username, setUserName] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [sendPassword, setSendPassword] = React.useState(false);
    const [rememberMe, setRememberMe] = React.useState(false);
    const [firstLoad, setFirstLoad] = React.useState(false);

    fastApi.hostname = props.host;
    fastApi.port = props.port;
    fastApi.ssl = window.location.port === '3000' ? false : true;
    fastApi.backendEndpoint = '/login';


    fastApi.loginSuccessCallback = (data) => {
        console.log('Login Success:', data);
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('username', username);
        localStorage.setItem('token_type', data.token_type);
        localStorage.setItem('LoginFailure', '');
        window.location.reload();
    };

    fastApi.loginFailureCallback = (error) => {
        console.error('Login Failure:', error.message);
        localStorage.setItem('LoginFailure', error.message);
        window.location.reload();
    };

    React.useEffect(() => {
        const storageRememberMe = JSON.parse(localStorage.getItem('rememberMe'));
        if(storageRememberMe) {
            setRememberMe(storageRememberMe);
        }
    }, []);

    React.useEffect(() => {
        if(firstLoad) {
            localStorage.setItem('rememberMe', rememberMe);
        }
    }, [rememberMe, firstLoad]);

    React.useEffect(() => {
        fastApi.setUsername(username);
    }, [username]);

    React.useEffect(() => {
        fastApi.setPassword(password);
    }, [password]);

    // Authorize the user
    React.useEffect(() => {
        if (sendPassword) {

            // Call the login API here
            fastApi.loginTimeout();

            // Reset the password and hashed password
            setPassword('');
            setSendPassword(false);
        }
    }, [sendPassword]);

    React.useEffect(() => {
        if (!firstLoad) {
            setFirstLoad(true);
        }
    }, [firstLoad]);


    function login(event) {
        event.preventDefault();
        setSendPassword(true);

        console.log('login clicked', event.target.value);
        if (props.loginCallback) {

            props.loginCallback();
        } else {
            console.warn('login clicked, but no callback provided!');
        }
    }

    function side() {
        return (
            <div>
                <h2>Welcome {props.appName ? "to" : null}<br /> {props.appName}</h2>
                <p>Login here to access.</p>
            </div>
        );
    }

    function loginForm() {
        return (
            <div className="login-form">
                {props?.loggedOutReason ? <div className="alert alert-danger">{props.loggedOutReason}</div> : null}
                {localStorage.getItem('LoginFailure') ? <div className="alert alert-danger">{localStorage.getItem('LoginFailure')}</div> : null}
                <form>
                    <div className="form-group mb-3">
                        <label className="mb-1">Username</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            onChange={(event) => setUserName(event.target.value)}
                            value={username}
                            autoComplete="username"
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>Password</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder=""
                            onChange={(event) => setPassword(event.target.value)}
                            value={password}
                            autoComplete="current-password"
                            autoFocus={true}
                        />
                    </div>
                    <div className="form-group mb-3">

                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={rememberMe}
                            onChange={(event) => {
                                setRememberMe(event.target.checked);
                            }}
                        />
                        <label className="mx-2">Remember me</label>
                    </div>
                </form>
                <button
                    className="btn btn-primary btn-block my-2 rounded-3"
                    onClick={login}
                    disabled={!username || !password}
                >
                    Login
                </button>
            </div>
        );
    }

    return (
        <div data-testid="loginPage" className="d-flex my-auto">
            <div className="container">
                <div className="row my-auto">
                    <div className="col-4 my-auto mx-auto">
                        {side()}
                    </div>
                    <div className="col-4 my-auto mx-auto">
                        {loginForm()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
